import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {FulfillmentFilterPayloadModel} from "../../models/fulfillment-filter-payload.model";
import {PaginatedResultModel} from "../../../commons/angular/models/paginated-result.model";
import {FulfillmentModel} from "../../models/fulfillment.model";

@Injectable({providedIn: 'root'})
export class FulfillmentHttpService {

  private base_url = `/fulfillment`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getFulfillments(page: number, size: number, payload: FulfillmentFilterPayloadModel): Observable<PaginatedResultModel<FulfillmentModel>> {
    let paginatedResult: PaginatedResultModel<any> = {
      content: undefined,
      pagination: undefined
    }
    return this.http.post<any>(`${this.base_url}/page/`, payload, {
      params: {
        page: page,
        size: size
      }
    }).pipe(
      map((res) => {
        paginatedResult.content = res.content;
        paginatedResult.pagination = {
          sort: res.sort,
          size: res.size,
          empty: res.empty,
          number: res.number,
          first: res.first,
          last: res.last,
          numberOfElements: res.numberOfElements
        }
        return paginatedResult
      })
    );
  }

  getFulfillment(fulfillmentId: string, expand?: boolean): Observable<FulfillmentModel> {
    let params: { expand?: boolean } = {}
    if (expand) {
      params.expand = true;
    }
    return this.http.get<FulfillmentModel>(`${this.base_url}/${fulfillmentId}`,
      {
        params: params
      })
  }

}
